import { getPage } from './getPage';
import { updateCart } from './updateCart'; 
import { getParam } from '../helpers/getParam'; 


const addToCartAction = (sku, quantity = 1) => {
  const uid = getParam('uid'); 
  let cart = JSON.parse(localStorage.getItem(`${uid}-cart`)) || []; 

  const productId = String(sku);
  const index = cart.findIndex(item => item.id === productId);

  if (index !== -1) {
    cart[index].quantity += quantity;
  } else {
    cart.push({
      id: productId,
      quantity: quantity
    });
  }

  localStorage.setItem(`${uid}-cart`, JSON.stringify(cart));
  
  if (typeof updateCart === 'function') {
    updateCart(); 
  }

  $('.popup-product').show(); 
  $('.popup-product__in .loader').hide(); 
  $('.after-load').addClass('show'); 
  $('.popup-product__in').addClass('loaded'); 
};

const setupPopupHandlers = () => {
  $(document).off('click', '.close_popup-product').on('click', '.close_popup-product', function (e) {
    e.preventDefault(); 
    $('.popup-product').hide();
    $('.popup-product__in .loader').show();
    $('.after-load').removeClass('show');
    $('.popup-product__in').removeClass('loaded');
  });
};


export const getProduct = (products, containerType, data) => {
  const getRandomInt = (min, max) => Math.floor(Math.random() * (max - min + 1)) + min;
  const currency = window.options?.currency || '$';
  let productHTML = '';

  if (containerType === 's3-cont' || containerType === 's44-cont') {
    const numProducts = containerType === 's3-cont' ? 6 : 3;
    const randomProducts = [];
    const filteredProducts = window.limitSliderToSix
      ? products.filter((p) => !p.nutrition_facts || p.nutrition_facts.length === 0)
      : products;

    const countToFetch = Math.min(numProducts, filteredProducts.length);
    while (randomProducts.length < countToFetch) {
      const randomIndex = getRandomInt(0, filteredProducts.length - 1);
      const randomProduct = filteredProducts[randomIndex];
      if (!randomProducts.some((p) => p.sku === randomProduct.sku)) {
        randomProducts.push(randomProduct);
      }
    }
    productHTML = randomProducts.map(product => renderStandardItem(product, currency)).join('');


  } else if (containerType === 's33-cont') {
    const $tabsContainer = $('.left-side .list');

    if ($tabsContainer.length && $tabsContainer.find('[data-tab]').length <= 1) {
      let tabsHTML = `<div class="itm active" data-tab="all"><h5>All Products</h5></div>`;
      products.forEach((product) => {
        tabsHTML += `<div class="itm" data-tab="${product.sku}"><h5>${product.templates.title}</h5></div>`;
      });
      $tabsContainer.html(tabsHTML);

      $tabsContainer.off('click', '.itm').on('click', '.itm', function () {
        const tabSku = $(this).attr('data-tab');
        $tabsContainer.find('.itm').removeClass('active');
        $(this).addClass('active');

        let filtered = tabSku === 'all' ? products : products.filter((p) => String(p.sku) === String(tabSku));
        getProduct(filtered, 's33-cont', data);
      });
    }
    productHTML = products.map(product => renderStandardItem(product, currency)).join('');

  } else if (containerType === 'dop-prod-cont') {
    const randomProducts = [];
    const countToFetch = Math.min(2, products.length);
    while (randomProducts.length < countToFetch) {
      const randomIndex = getRandomInt(0, products.length - 1);
      const randomProduct = products[randomIndex];
      if (!randomProducts.some((p) => p.sku === randomProduct.sku)) randomProducts.push(randomProduct);
    }
    productHTML = randomProducts.map(product => renderDopItem(product)).join('');
  }


  $(`.${containerType}`).html(productHTML);


  $(document).off('click', '.add_to_cart').on('click', '.add_to_cart', function (e) {
    e.preventDefault(); 
    e.stopPropagation(); 
    const sku = $(this).data('sku') || $(this).closest('.itm').data('sku'); 
    if (sku) {
      addToCartAction(sku, 1);
    }
  });

  $(document).off('click', '.itm').on('click', '.itm', function (e) {
    // Если это контейнер с доп. товарами, разрешаем переход только при клике на get_product_detail
    if ($(this).closest('.dop-prod-cont').length) {
      if (!$(e.target).closest('.get_product_detail').length) return;
    }

    if ($(e.target).closest('.add_to_cart').length) return;
    
    const sku = $(this).data('sku');
    if (sku) {
      localStorage.setItem('product', sku);
      window.location.href = `${getPage('product')}&id=${sku}`;
    }
  });

  setupPopupHandlers();
};


function renderStandardItem(product, currency) {
  const rnd = (min, max) => Math.floor(Math.random() * (max - min + 1)) + min;
  const discount = rnd(15, 30);
  const originalPrice = (product.price / (1 - discount / 100)).toFixed(2);
  const soldCount = `${rnd(1, 9)}.${rnd(1, 9)}k`;

  return `
    <div class="itm" data-sku="${product.sku}">
      <div class="img">
        <div class="overlay"></div>
        <div class="discount-badge">-${discount}%</div>
        <img src="/static/common/shared/products/${product.templates.imageLink}">
        <a class="add_to_cart" data-sku="${product.sku}">
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
            <path d="M12.75 6.75L0.75 6.75" stroke="black" stroke-width="1.5" stroke-linecap="round"/>
            <path d="M6.75 0.75V12.75" stroke="black" stroke-width="1.5" stroke-linecap="round"/>
          </svg> Add to cart
        </a>
      </div>
      <div class="text">
        <div class="prod-meta">
          <div class="prod-stars">★★★★★</div>
          <span class="prod-sold">${soldCount} sold</span>
        </div>
        <h2>${product.templates.title}</h2>
        <div class="prod-price">
          <h3>${currency}${product.price.toFixed(2)}</h3>
          <span class="prod-old-price">${currency}${originalPrice}</span>
        </div>
      </div>
    </div>`;
}

function renderDopItem(product) {
  return `
    <div class="itm" data-sku="${product.sku}">
      <img src="/static/common/shared/products/${product.templates.imageLink}">
      <div class="text">
        <h3>${product.templates.title}</h3>
        <a class="get_product_detail" style="cursor: pointer;">
          GO TO PRODUCT
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M3.3335 8H12.6668" stroke="#0F172A" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M8 3.33337L12.6667 8.00004L8 12.6667" stroke="#0F172A" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </a>
      </div>
    </div>`;
}